'use client';

import { memo, useCallback } from 'react';

import { Accordion, AccordionItem } from '@heroui/react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { v4 as uuidv4 } from 'uuid';

import { AccordionMenuProps } from './interface';

function AccordionMenu({
  items,
  title,
  openIcon: OpenIcon = IoIosArrowUp,
  closeIcon: CloseIcon = IoIosArrowDown,
}: AccordionMenuProps) {
  const renderIndicator = useCallback(
    (props: { isOpen?: boolean }) => {
      const isOpen = props.isOpen ?? false;
      return isOpen ? <OpenIcon className="text-white" /> : <CloseIcon className="text-white" />;
    },
    [OpenIcon, CloseIcon]
  );

  return (
    <div className="relative">
      {title && (
        <h4 className="text-hforeground font-title text-base md:text-lg font-extrabold">
          {title}
        </h4>
      )}

      <Accordion
        isCompact
        className="!p-0"
        itemClasses={{
          base: 'bg-hbackground mb-2 rounded-md px-3 text-white',
          title: 'text-white px-1',
        }}
      >
        {items.map((item) => {
          return (
            <AccordionItem
              key={uuidv4()}
              title={item.title}
              startContent={item.startContent}
              indicator={renderIndicator}
            >
              {item.expandedContent}
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}

export const AccordionMenuMemo = memo(AccordionMenu);
export { AccordionMenuMemo as AccordionMenu };
